import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { getKioskMonitoringSummary } from "../../../services/kioskDashboard.service";
import { buildMonitoringQuery } from "./kioskDashboard.helpers";

export const useKioskMonitoringData = (filters = {}, enabled = true) => {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const mountedRef = useRef(false);
  const requestRef = useRef(0);
  const filterKey = JSON.stringify(filters || {});
  const stableFilters = useMemo(() => JSON.parse(filterKey), [filterKey]);

  const load = useCallback(async () => {
    const requestId = requestRef.current + 1;
    requestRef.current = requestId;
    if (mountedRef.current) setState(previous => ({ ...previous, loading: true, error: null }));
    try {
      const data = await getKioskMonitoringSummary(buildMonitoringQuery(stableFilters));
      if (mountedRef.current && requestRef.current === requestId) {
        setState({ data, loading: false, error: null });
      }
    } catch (error) {
      if (mountedRef.current && requestRef.current === requestId) {
        setState({ data: null, loading: false, error });
      }
    }
  }, [stableFilters]);

  useEffect(() => {
    mountedRef.current = true;
    if (enabled) {
      load();
    } else {
      setState(previous => ({ ...previous, loading: false, error: null }));
    }
    return () => {
      mountedRef.current = false;
    };
  }, [load, enabled]);

  return {
    ...state,
    reload: load,
  };
};
